module.exports = __webpack_public_path__ + "static/img/charge11.156e2450.gif";